export enum recipientReducerActionTypes {
  UPDATE_NAME = 'RECIPIENT_UPDATE_NAME',
  UPDATE_FORM_VALID = 'RECIPIENT_UPDATE_FORM_VALID',
}

interface RecipientUpdateNameAction {
  type: recipientReducerActionTypes.UPDATE_NAME;
  payload: string;
}

interface RecipientUpdateFormValidAction {
  type: recipientReducerActionTypes.UPDATE_FORM_VALID;
  payload: boolean;
}

export type RecipientReducerAction =
  | RecipientUpdateNameAction
  | RecipientUpdateFormValidAction;

export interface RecipientReducerState {
  name: string;
  formValid: boolean;
}

export const recipientReducerInitialState: RecipientReducerState = {
  name: '',
  formValid: false,
};

const recipientReducer = (
  state: RecipientReducerState,
  action: RecipientReducerAction
): RecipientReducerState => {
  switch (action.type) {
    case recipientReducerActionTypes.UPDATE_NAME: {
      return {
        ...state,
        name: action.payload,
      };
    }
    case recipientReducerActionTypes.UPDATE_FORM_VALID: {
      return {
        ...state,
        formValid: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default recipientReducer;
